module.exports = __webpack_public_path__ + "img/sensing.2c54c4e6.jpg";